@if (initialized && activeNavigationItem) {
    <div class="config-content-container surface-0">

        @switch (activeNavigationItem.action) {
            @case ('ig.IgAccessToken') {
                <div class="table-container">
                    @if (widgets?.igAccessTokenWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.igAccessTokenWidget.widgetData"
                                (onObjectSelect)="handleObjectSelect($event)">
                        </mvs-widget>
                    }
                </div>
            }
            @case ('ig.IgAccessTokenUsed') {
                <div class="surface-0 border-round h-full">
                    <div class="grid h-full m-0">

                        <!-- Sidebar: pick the token whose accesses should be shown -->
                        <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                            @if (widgets?.igAccessTokenSelectableWidget) {
                                <mvs-widget
                                        [widgetData]="widgets?.igAccessTokenSelectableWidget.widgetData"
                                        (onObjectSelect)="onAccessTokenSelect($event)"
                                        (onObjectDeselect)="onAccessTokenDeselect()">
                                </mvs-widget>
                            }
                        </div>

                        <!-- Main: usage log, unfiltered or narrowed to the selected token -->
                        <div class="col-12 md:col-8 lg:col-9 h-full p-2 pt-0 scroll-table-container">
                            @if (accessTokenUsedWidget) {
                                <mvs-widget
                                        [widgetData]="accessTokenUsedWidget"
                                        [disableUpdate]="true"
                                        (onObjectSelect)="handleLogObjectSelect($event)">
                                </mvs-widget>
                            }
                        </div>

                    </div>
                </div>
            }
            @case ('ig.IgPassToken') {
                <div class="table-container">
                    @if (widgets?.igPassTokenWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.igPassTokenWidget.widgetData"
                                (onObjectSelect)="handleObjectSelect($event)">
                        </mvs-widget>
                    }
                </div>
            }
            @case ('ig.IgPassTokenUsed') {
                <div class="surface-0 border-round h-full">
                    <div class="grid h-full m-0">

                        <!-- Sidebar: pick the pass token whose accesses should be shown -->
                        <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                            @if (widgets?.igPassTokenSelectableWidget) {
                                <mvs-widget
                                        [widgetData]="widgets?.igPassTokenSelectableWidget.widgetData"
                                        (onObjectSelect)="onPassTokenSelect($event)"
                                        (onObjectDeselect)="onPassTokenDeselect()">
                                </mvs-widget>
                            }
                        </div>

                        <!-- Main: usage log, unfiltered or narrowed to the selected token -->
                        <div class="col-12 md:col-8 lg:col-9 h-full p-2 pt-0 scroll-table-container">
                            @if (passTokenUsedWidget) {
                                <mvs-widget
                                        [widgetData]="passTokenUsedWidget"
                                        [disableUpdate]="true"
                                        (onObjectSelect)="handleLogObjectSelect($event)">
                                </mvs-widget>
                            }
                        </div>

                    </div>
                </div>
            }
        }

    </div>
}
